<template lang="html">
    <d-row>
      <d-col cols="12" class="mb-4">
        <d-card v-if="projects.length > 0">
          <d-card-header class="border-bottom">
            <d-form-row>
              <d-col cols="12" md="6" class="d-flex mb-0 align-items-center">
                <h6 class="m-0">Progresso da obra</h6>
              </d-col>
              <d-col cols="12" md="6" class="form-group d-flex mb-0 align-items-center" v-if="projects.length > 1" >
                <label for="Project" class="mb-0">Obras</label>
                <d-select
                  class="ml-3"
                  size="sm"
                  v-model="project"
                >
                  <option v-for="(project, index) in projects" :key="index" :value="project">{{ project.label }}</option>
                </d-select>
                <d-form-invalid-feedback>Obra é obrigatório</d-form-invalid-feedback>
              </d-col>
            </d-form-row>
          </d-card-header>
          <d-card-body>
            <d-row class="justify-content-center pr-5 pl-4 project-status">
              <d-col v-for="(status, index) in project.project_status" :key="index" class="col-status mx-0 p-0 d-flex align-items-center">
                <d-progress :theme="statusClass(status)" height="5px" :value="statusValue(status, index)" :max="100" class="m-auto progresso-obra"/>
                <d-col class="icon-circle p-0">
                  <i :class="['material-icons', statusClass(status)]">{{ status.icon }}</i>
                  <div class="d-block text-center">{{ status.name }}</div>
                </d-col>
              </d-col>
            </d-row>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>

</template>

<script>
import CustomerService from '_services/rest/modules/customer';
import { MODEL_PROJECT_STATUS } from '_modules/project/components/ProjectModel';

export default {
  name: 'project-status',
  props: {},
  data() {
    return {
      projects: [],
      project: { ...MODEL_PROJECT_STATUS },
    };
  },
  computed: {},
  components: {},
  methods: {
    getProjects() {
      const { user } = this.$store.state.user;
      CustomerService.getProjectByCutomerId(user.settings.customer_id)
        .then(response => {
          this.projects = response;
          if (this.projects.length === 1) {
            [this.project] = this.projects;
          }
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    statusClass(status) {
      if (status.pivot.finished_at) {
        return 'success';
      }
      return 'primary';
    },
    statusValue(status, index) {
      let prevStatus = null;
      if (index > 0) {
        prevStatus = this.project.project_status[index - 1].pivot.finished_at;
      }
      if (prevStatus && !status.pivot.finished_at) {
        return 50;
      }
      if (status.pivot.finished_at) {
        return 100;
      }
      return 0;
    },
  },
  mounted() {
    this.getProjects();
  },
};
</script>

<style lang="scss">
.progresso-obra {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.material-icons {
  border-radius: 20px 20px;
  width: 40px;
  text-align: center;
  vertical-align: middle;
  height: 40px;
  font-size: 25px;
  color: white;
  padding-top: 6px;
  &.success {
    background: #17c671;
  }
  &.primary {
    background: #f5f5f6;
  }
}

.icon-circle {
  width: 80px;
  position: absolute;
  right: -25px;
  text-align: center;
  z-index: 99;
  top: 0px;
}
.col-status {
  height: 50px;
  margin-bottom: 30px;
  &:first-child {
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
}

@media (max-width: 602px) {
  .project-status {
    flex-direction: column;
    padding: 1rem!important;
    .col-status {
      margin-bottom: 35px;
      flex: 0 0 100%;
      max-width: 100%;
      position: relative;
      &:first-child {
        .progresso-obra {
          display: none;
        }
      }
      .progresso-obra {
        transform: rotate(90deg);
        right: 25%!important;
        position: absolute;
        top: -37px;
        width: 50%;
        z-index: 0;
      }
      .icon-circle {
        margin-top: 0px;
        position: relative;
        z-index: 2;
        right: 0;
        .d-block {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
